import { useFlippers } from "@shared/context/FlippersContext";

import { useExperiment, type UseExperimentProps } from "../useExperiment/useExperiment";

const useTitanExplicitTosExperiment = (): boolean => {
  const [isTitanExplicitTosEnabled] = useFlippers("titan_explicit_tos");
  const group = useExperiment({
    experiment: "titan_explicit_tos_experiment",
    groups: ["CONTROL", "EXPERIMENT"],
    owner: "titan",
    e2eGroup: "CONTROL",
    shouldLog: isTitanExplicitTosEnabled,
    authedExperiment: true,
    unauthedExperiment: true,
  } as UseExperimentProps<"CONTROL" | "EXPERIMENT">);

  return group === "EXPERIMENT" && isTitanExplicitTosEnabled;
};

export { useTitanExplicitTosExperiment };
